import React from "react";
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
} from "@fluentui/react";
import type { IColumn } from "@fluentui/react";
import type { HeaderEntry } from "@/api/telemetry";
import styles from "@/components/telemetry/detail/HeadersTable.module.css";

interface HeadersTableProps {
  headers: HeaderEntry[];
  title: string;
}

const COLUMNS: IColumn[] = [
  {
    key: "headerName",
    name: "Name",
    fieldName: "headerName",
    minWidth: 150,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "headerValue",
    name: "Value",
    fieldName: "headerValue",
    minWidth: 200,
    isResizable: true,
  },
];

function HeadersTable({ headers, title }: HeadersTableProps) {
  if (headers.length === 0) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      <DetailsList
        items={headers}
        columns={COLUMNS}
        layoutMode={DetailsListLayoutMode.justified}
        selectionMode={SelectionMode.none}
        isHeaderVisible
        compact
      />
    </div>
  );
}

export default HeadersTable;
